export const initBadges = () => {
  const badges = document.getElementById("badges");

  if (!badges) {
    return;
  }

  const shareFacebookBtn = badges.querySelector(".trophy.share-facebook .btn") as HTMLDivElement;
  const shareTwitterBtn = badges.querySelector(".trophy.share-twitter .btn") as HTMLDivElement;
  const facebookLikeBtn = badges.querySelector(".trophy.like-facebook .btn") as HTMLDivElement;
  const followInstagramBtn = badges.querySelector(
    ".trophy.follow-instagram .btn",
  ) as HTMLDivElement;
  const followTiktokBtn = badges.querySelector(".trophy.follow-tiktok .btn") as HTMLDivElement;
  const followLinkedinBtn = badges.querySelector(".trophy.follow-linkedin .btn") as HTMLDivElement;
  const reviewFacebookBtn = badges.querySelector(".trophy.review-facebook .btn") as HTMLDivElement;
  const reviewGoogleBtn = badges.querySelector(".trophy.review-google .btn") as HTMLDivElement;
  const reviewTrustpilotBtn = badges.querySelector(
    ".trophy.review-trustpilot .btn",
  ) as HTMLDivElement;
  const posterBtn = badges.querySelector(".trophy.poster .btn") as HTMLDivElement;

  if (shareFacebookBtn) {
    shareFacebookBtn.addEventListener("click", () => {
      shareFacebookBtn.innerHTML =
        '<span role="status" class="spinner-border spinner-border-sm"><span class="visually-hidden">...</span></span>';
      send(
        "/website-api/badges/facebook_shared/",
        badges.querySelector(".trophy.share-facebook") as HTMLDivElement,
      );
    });
  }

  if (shareTwitterBtn) {
    shareTwitterBtn.addEventListener("click", () => {
      shareTwitterBtn.innerHTML =
        '<span role="status" class="spinner-border spinner-border-sm"><span class="visually-hidden">...</span></span>';
      send(
        "/website-api/badges/twitter_shared/",
        badges.querySelector(".trophy.share-twitter") as HTMLDivElement,
      );
    });
  }

  if (facebookLikeBtn) {
    facebookLikeBtn.addEventListener("click", () => {
      facebookLikeBtn.innerHTML =
        '<span role="status" class="spinner-border spinner-border-sm"><span class="visually-hidden">...</span></span>';
      send(
        "/website-api/badges/facebook_liked/",
        badges.querySelector(".trophy.like-facebook") as HTMLDivElement,
      );
    });
  }

  if (followInstagramBtn) {
    followInstagramBtn.addEventListener("click", () => {
      followInstagramBtn.innerHTML =
        '<span role="status" class="spinner-border spinner-border-sm"><span class="visually-hidden">...</span></span>';
      send(
        "/website-api/badges/instagram_followed/",
        badges.querySelector(".trophy.follow-instagram") as HTMLDivElement,
      );
    });
  }

  if (followTiktokBtn) {
    followTiktokBtn.addEventListener("click", () => {
      followTiktokBtn.innerHTML =
        '<span role="status" class="spinner-border spinner-border-sm"><span class="visually-hidden">...</span></span>';
      send(
        "/website-api/badges/tiktok_followed/",
        badges.querySelector(".trophy.follow-tiktok") as HTMLDivElement,
      );
    });
  }

  if (followLinkedinBtn) {
    followLinkedinBtn.addEventListener("click", () => {
      followLinkedinBtn.innerHTML =
        '<span role="status" class="spinner-border spinner-border-sm"><span class="visually-hidden">...</span></span>';
      send(
        "/website-api/badges/linkedin_followed/",
        badges.querySelector(".trophy.follow-linkedin") as HTMLDivElement,
      );
    });
  }

  if (reviewFacebookBtn) {
    reviewFacebookBtn.addEventListener("click", () => {
      reviewFacebookBtn.innerHTML =
        '<span role="status" class="spinner-border spinner-border-sm"><span class="visually-hidden">...</span></span>';
      send(
        "/website-api/badges/review_facebook/",
        badges.querySelector(".trophy.review-facebook") as HTMLDivElement,
      );
    });
  }

  if (reviewGoogleBtn) {
    reviewGoogleBtn.addEventListener("click", () => {
      reviewGoogleBtn.innerHTML =
        '<span role="status" class="spinner-border spinner-border-sm"><span class="visually-hidden">...</span></span>';
      send(
        "/website-api/badges/review_google/",
        badges.querySelector(".trophy.review-google") as HTMLDivElement,
      );
    });
  }

  if (reviewTrustpilotBtn) {
    reviewTrustpilotBtn.addEventListener("click", () => {
      reviewTrustpilotBtn.innerHTML =
        '<span role="status" class="spinner-border spinner-border-sm"><span class="visually-hidden">...</span></span>';
      send(
        "/website-api/badges/review_trustpilot/",
        badges.querySelector(".trophy.review-trustpilot") as HTMLDivElement,
      );
    });
  }

  if (posterBtn) {
    posterBtn.addEventListener("click", () => {
      posterBtn.innerHTML =
        '<span role="status" class="spinner-border spinner-border-sm"><span class="visually-hidden">...</span></span>';
    });
  }

  function send(url: string, element: HTMLDivElement) {
    fetch(url, {
      credentials: "same-origin",
      method: "post",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.metadata.code === 200) {
          element.classList.add("active");
        }
        if (data.metadata.code === 401) {
          window.location.href = "/";
        }

        if (data.metadata.code === 409) {
          // conflict, already unlocked
        }
      });
  }
};
